import React, { FC } from 'react';
import { Cell, Pie, PieChart } from 'recharts';
import { CountResult, DonutChartCont, ResultTextCont, ShareResult } from './DonutChart.styles';

interface IDonutChart {
  colors: string[];
  count: number;
  data: { name: string; value: number }[];
  dataKey: string;
  height?: number;
  width?: number;
  startAngle?: number;
  endAngle?: number;
  cornerRadius?: number;
  innerRadius?: number;
  outerRadius?: number;
  paddingAngle?: number;
  share: number;
  onClick?: (event: React.MouseEvent<SVGElement>) => void;
  isAnimationActive?: boolean;
}

const DonutChart: FC<IDonutChart> = ({
  colors,
  count,
  data = [],
  dataKey,
  height = 200,
  width = 200,
  startAngle = 90,
  endAngle = -360,
  cornerRadius = 4,
  innerRadius = 64,
  outerRadius = 96,
  paddingAngle = 2,
  share,
  onClick,
  isAnimationActive = false,
}) => (
  <DonutChartCont>
    <PieChart {...{ height, width }}>
      <Pie
        cx="50%"
        cy="50%"
        {...{
          data,
          dataKey,
          startAngle,
          endAngle,
          cornerRadius,
          innerRadius,
          outerRadius,
          paddingAngle,
          isAnimationActive,
        }}
      >
        {data.map((_, index: number) => (
          <Cell
            key={`cell-${index}`}
            id={`${index}`}
            fill={colors[index % colors.length]}
            stroke={colors[index % colors.length]}
            {...{ onClick }}
          />
        ))}
      </Pie>
    </PieChart>
    <ResultTextCont id="ResultTextCont">
      <ShareResult>{share}%</ShareResult>
      <CountResult>({count})</CountResult>
    </ResultTextCont>
  </DonutChartCont>
);

export default DonutChart;
